import { Flex, Typography } from "antd"

import "./SectionHeader.less"

const { Text } = Typography

const SectionHeader = ({ title, image, marginBottom }) => {
  return (
    <Flex gap={8} className="health-monitoring-program-header" style={{ marginBottom }}>
      <img width={20} height={20} src={image} alt={title} />
      <Text className="header-text">{title}</Text>
    </Flex>
  )
}

export default SectionHeader
